<script>
import axios from '@/utils/axios';
import { Modal } from 'bootstrap';
import { getBranches } from '@/utils/branch';
import { useToast } from 'vue-toastification';
import { permissionsMixin } from '@/mixins/userPermissions';
import QuotationChart from '@/components/analytic/quotation-chart';
import LeadStageChart from '@/components/analytic/lead-stage-chart';
import LeadSourceChart from '@/components/analytic/lead-source-chart';
import TopSellingItemChart from '@/components/analytic/top-selling-item-chart';

export default {
  inject: ['setLoading'],
  mixins: [permissionsMixin],
  components: {
    LeadStageChart,
    QuotationChart,
    LeadSourceChart,
    TopSellingItemChart
  },
  data() {
    return {
      branch: null,
      low_stock_count: 0,
      branch_id: '',
      branches: [],
      quotation_by_status: [],
      chartKey: 0,
      chartKeyUserRole: 0,
      chartKeyProposalStatus: 0,
      chartKeyQuotationStatus: 0,
      chartKeySourceStatus: 0,
      chartKeyTopSellingItemStatus: 0,
      errors: {},
      title: "Admin Dashboard",
      text: "Dashboard",
      text1: "Admin Dashboard",
      isCollapsed: false,
      toast: useToast(),
      total: {
        users: 0,
        leads: 0,
        customers: 0,
        active_leads: 0,
        converted_leads: 0,
        items: 0,
        proposals: 0,
        quotations: 0,
      },
      todays_reminder: 0,
      stage_wise_lead_distribution: [],
      lead_stage_chart_config: {
        type: 'doughnut',
        data: {
          labels: [],
          datasets: [{
            label: 'Lead Stage',
            data: [],
            backgroundColor: [],
            borderWidth: 5,
            borderRadius: 10,
            borderColor: '#fff',
            hoverBorderWidth: 0,
            cutout: '60%',
          }]
        },
        options: {
          rotation: -100,
          circumference: 200,
          layout: { padding: { top: -20, bottom: -20 } },
          responsive: true,
          maintainAspectRatio: false,
          plugins: { legend: { display: false } }
        }
      },

      source_wise_lead_distribution: [],
      top_selling_items: [],

      proposal_status_chart_config: {
        type: 'bar',
        stacked: true,
        data: {
          labels: [],
          datasets: [{
            label: 'Proposal Status',
            data: [],
            backgroundColor: [],
            borderWidth: 1,
            borderColor: '#fff',
            borderRadius: 4,
            hoverBorderWidth: 0,
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              display: true,
              position: 'bottom',
            }
          },
          scales: {
            y: {
              beginAtZero: true,
              ticks: {
                // stepSize: 1,
              },
            },
          }
        },
      },

      quotation_status_chart_config: {
        type: 'line',       
        data: {
          labels: [],
          datasets: [{
            label: 'Quotation Status',
            data: [],
            backgroundColor: [],
            borderWidth: 2,
            borderColor: [],
            fill: true,       
            tension: 0.4,      
            pointRadius: 5,
            pointHoverRadius: 7,
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              display: true,
              position: 'bottom',
            }
          },
          scales: {
            y: {
              beginAtZero: true,
              ticks: {
                callback: (value) => {
                  if(value >= 100000) return (value/100000).toFixed(1) + 'L';
                  if(value >= 1000) return (value/1000).toFixed(1) + 'K';
                  return value;
                }
              },
            },
          }
        },
      },

      user_roles: {
        roles: {
          chart: {
            height: 220,
            type: 'bar',
            padding: { top: 0, left: 0, right: 0, bottom: 0 },
            toolbar: { show: false },
          },
          colors: ['#66BB6A'],
          grid: {
            borderColor: '#66BB6A',
            strokeDashArray: 5,
            padding: { top: -20, left: 0, right: 0, bottom: 0 }
          },
          plotOptions: {
            bar: {
              borderRadius: 5,
              horizontal: false,
              columnWidth: '30%',
              endingShape: 'rounded'
            }
          },
          dataLabels: { enabled: false },
          xaxis: {
            categories: [],  
            labels: {
              style: { colors: '#66BB6A', fontSize: '13px' }
            }
          },
        },
        series: [{
          data: [],  
          name: 'Users'
        }]
      },
      total_sampling_requests: '',
      overdue_sampling_requests: '',
      pending_sampling_requests: ''

    };
  },

  computed: {
    leadChartData() {
      return {
        total_leads: this.total.leads,
        active_leads: this.total.active_leads,
        stage_wise_lead_distribution: this.stage_wise_lead_distribution
      };
    },
    quotationReportData() {
      return {
        total_quotations: this.total.quotations,
        quotation_by_status: this.quotation_by_status
      };
    }

  },

  mounted() {
    this.allBranches();
    this.dashboardData();
    this.setPermissions(this.auth);
    this.loadLowStock();
  },

  methods: {

    async loadLowStock() {
  try {
    const response = await axios.get('/inventory/stocks/low-stock');
    this.low_stock_count = response.data.data.total_low_stock_items || 0;
  } catch (error) {
    console.error('Low stock fetch failed:', error.message);
  }
},

    async allBranches() {
      this.branches = await getBranches();
    },

    openStageLeads(stage) {
      this.$refs.chartModal.getLeads(
        '',                 // user_id
        '',                 // from_date
        '',                 // to_date
        stage.stage_id,     // lead_stage_id from stage object
        this.branch_id,     // branch_id from parent
        1                   // page
      );

      // show Bootstrap modal
      const modalEl = document.getElementById('lead_detail_modal');
      if (modalEl) {
        const modal = Modal.getOrCreateInstance(modalEl);
        modal.show();
      }
    },

    async dashboardData() {
      this.setLoading(true);
      try {
        this.branch_id = this.branch?.id || '';
        const params = {
          branch_id: this.branch_id
        };
        const query_string = new URLSearchParams(params).toString();
        const response = await axios.get(`/dashboard?${query_string}`);
        this.total.users = response.data.data.total_users;
        this.total.leads = response.data.data.total_leads;
        this.total.customers = response.data.data.total_customers;
        this.total.active_leads = response.data.data.active_leads;
        this.total.converted_leads = response.data.data.converted_leads;
        this.total.items = response.data.data.total_items;
        this.total.proposals = response.data.data.total_proposals;
        this.total.quotations = response.data.data.total_quotations;
        this.todays_reminder = response.data.data.todays_reminder;
        this.total_sampling_requests = response.data.data.total_sampling_requests;
        this.overdue_sampling_requests = response.data.data.overdue_sampling_requests;
        this.pending_sampling_requests = response.data.data.pending_sampling_requests;

        const distribution = response.data.data.stage_wise_lead_distribution || [];
        this.stage_wise_lead_distribution = distribution;

        this.lead_stage_chart_config = {
          type: 'doughnut',
          data: {
            labels: distribution.map(s => s.stage),
            datasets: [{
              label: "Lead Stages",
              data: distribution.map(s => Number(s.percentage) || 0),
              backgroundColor: distribution.map(s => s.color || '#999'),
              borderWidth: 5,
              borderRadius: 10,
              borderColor: '#fff',
              hoverBorderWidth: 0,
              cutout: '60%',
            }]
          },
          options: {
            rotation: -100,
            circumference: 200,
            layout: { padding: { top: -20, bottom: -20 } },
            responsive: true,
            maintainAspectRatio: false,
            plugins: { legend: { display: false } }
          }
        };
        //FORCE CHART RELOAD
        this.chartKey++;

        // ##########################################
        //            PROPOSAL CHART 
        // ##########################################

        const statusColors = {
          Draft: '#FFA726',
          Sent: '#29B6F6',
          Accepted: '#66BB6A',
          Rejected: '#EF5350'
        };

        const proposal_by_status = response.data.data.proposal_by_status;

        this.proposal_status_chart_config.data = {
          labels: ['Proposals'],  // single label on x-axis; bars stacked or grouped on this
          datasets: proposal_by_status.map(item => ({
            label: item.status,
            data: [item.count],    // each dataset has one value, for the single x-axis grouping
            backgroundColor: statusColors[item.status] || '#999999',
            borderWidth: 1,
            borderColor: '#fff',
            borderRadius: 4,
            hoverBorderWidth: 0,
          }))
        };

        this.chartKeyProposalStatus++;

        // ##########################################
        //            QUOTATION CHART 
        // ##########################################  

        const quotation_by_status = response.data.data.quotation_by_status;
        this.quotation_by_status = quotation_by_status;
        this.quotation_status_chart_config.data = {
          labels: quotation_by_status.map(item => item.status),  // ← x-axis pe statuses
          datasets: [{
            label: 'Quotation Amount',
            data: quotation_by_status.map(item => item.amount),  // ← amounts
            backgroundColor: 'rgba(41, 182, 246, 0.2)',          // ← light fill
            borderColor: '#29B6F6',                               // ← line color
            borderWidth: 2,
            fill: true,
            tension: 0.4,
            pointRadius: 5,
            pointBackgroundColor: '#29B6F6',
            pointHoverRadius: 7,
          }]
        };

        this.chartKeyQuotationStatus++;

        // ##########################################
        //            USER ROLES CHART 
        // ##########################################  

        const users_by_roles = response.data.data.users_by_roles;

        this.user_roles.roles.xaxis.categories = users_by_roles.map(item => item.role);
        this.user_roles.series[0].data = users_by_roles.map(item => item.count);

        this.chartKeyUserRole++;

        // ##########################################
        //            LEAD SOURCE CHART 
        // ########################################## 

        this.source_wise_lead_distribution = response.data.data.source_wise_lead_distribution;
        this.chartKeySourceStatus++;

        // ##########################################
        //          TOP SELLING ITEM CHART 
        // ##########################################  

        this.top_selling_items = response.data.data.top_selling_items;
        this.chartKeyTopSellingItemStatus++;

      } catch (error) {
        console.error(error.message);
        this.toast.error('Failed to load dashboard data');
      } finally {
        this.setLoading(false);
      }
    },

  },
};
</script>


<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>
  <div class="page-wrapper">
    <div class="content">
      <!-- Breadcrumb -->
      <div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
        <breadcrumb :title="title" :text="text" :text1="text1" />
        <div class="d-flex my-xl-auto right-content align-items-center flex-wrap">
          <!-- <div class="me-2 mb-2">
<div class="dropdown">
<a href="javascript:void(0);" class="dropdown-toggle btn btn-white d-inline-flex align-items-center" data-bs-toggle="dropdown">
 <i class="ti ti-file-export me-1"></i>Export </a>
<ul class="dropdown-menu dropdown-menu-end p-3">
 <li>
  <a href="javascript:void(0);" class="dropdown-item rounded-1"><i class="ti ti-file-type-pdf me-1"></i>Export as PDF</a>
 </li>
 <li>
  <a href="javascript:void(0);" class="dropdown-item rounded-1"><i class="ti ti-file-type-xls me-1"></i>Export as Excel</a>
 </li>
</ul>
 </div>
</div> -->
          <!-- <div class="mb-2">
<div class="input-icon w-120 position-relative">
 <span class="input-icon-addon"> 
  <i class="ti ti-calendar text-gray-9"></i>
 </span>
 <a-date-picker class="form-control yearpicker" picker="year" value="2025" placeholder="2025" />
</div>
</div> -->
          <div class="ms-2 head-icons custom-vueselect" v-if="auth?.type === 'ADMIN'">
            <vue-select :options="branches" label="name" v-model="branch" placeholder="All Branches"
              @update:modelValue="dashboardData" />
          </div>
        </div>
      </div>
      <!-- /Breadcrumb -->

      <div class="card" style="border:none">
        <div class="card-body d-flex align-items-center justify-content-between flex-wrap pb-1 bg-white">
          <div class="d-flex align-items-center mb-3">
            <span class="avatar avatar-xl flex-shrink-0">
              <img v-if="auth?.image" :src="auth?.image_url" class="rounded-circle" alt="img" />
              <i v-else class="ti ti-user-circle" style="font-size:48px;color:#cbd5e1;"></i>
            </span>
            <div class="ms-3">
              <h3 class="mb-2">
                Welcome Back, {{ auth?.name }}
                <router-link to="/profile" class="edit-icon"><i class="ti ti-edit fs-14"></i></router-link>
              </h3>
              <p>Here’s what’s happening with your business today.</p>
            </div>
          </div>

          <!-- overdue card -->
          <div v-if="overdue_sampling_requests > 0 && auth?.type === 'ADMIN'" class="col-lg-3 col-12">
            <div class="card border-0 alert-card-overdue position-relative overflow-hidden"
              style="border-radius: 12px; border: 1px solid #f5c2c7 !important; background: #fff;">
              <div class="card-body p-3">

                <div class="d-flex align-items-center mb-3">
                  <!-- Icon + Blinking dot -->
                  <div class="alert-icon-wrapper position-relative me-3">
                    <div
                      style="width:42px; height:42px; border-radius:10px; background:#fee2e2; display:flex; align-items:center; justify-content:center;">
                      <i class="ti ti-alert-circle text-danger" style="font-size:22px;"></i>
                    </div>
                    <div class="blinking-dot-danger"
                      style="position:absolute; top:-3px; right:-3px; width:10px; height:10px; border-radius:50%; background:#dc3545; border:2px solid #fff5f5;">
                    </div>
                  </div>

                  <!-- Title + Subtitle -->
                  <div class="flex-grow-1">
                    <h6 class="mb-0 fw-bold text-danger" style="font-size:14px; letter-spacing:0.03em;">OVERDUE SAMPLING
                    </h6>
                    <p class="mb-0 text-muted" style="font-size:12px;">Action required now!</p>
                  </div>

                  <!-- Count Badge -->
                  <div style="background:#fee2e2; border-radius:8px; padding:4px 12px; text-align:center;">
                    <span class="fw-bold text-danger" style="font-size:26px; line-height:1;">{{
                      overdue_sampling_requests }}</span>
                    <p class="mb-0 text-danger" style="font-size:10px; opacity:0.7;">overdue</p>
                  </div>
                </div>

                <!-- Divider -->
                <hr style="border-color:#f5c2c7; margin: 0 0 12px 0;">

                <!-- Button -->
                <router-link :to="`/finance-accounts/samplings?status=overdue`"
                  class="btn btn-danger btn-sm fw-semibold w-100" style="font-size:13px; border-radius:8px;">
                  <i class="ti ti-clock-exclamation me-1"></i> Fix Now
                </router-link>

              </div>
            </div>
          </div>
          
          <!-- Low Stock Alert Card -->
<div v-if="low_stock_count > 0" class="col-lg-3 col-12">
  <div class="card border-0 position-relative overflow-hidden"
    style="border-radius:12px; border:1px solid #fde68a !important; background:#fff;">
    <div class="card-body p-3">

      <div class="d-flex align-items-center mb-3">
        <!-- Icon + Blinking dot -->
        <div class="alert-icon-wrapper position-relative me-3">
          <div style="width:42px;height:42px;border-radius:10px;background:#fef9c3;display:flex;align-items:center;justify-content:center;">
            <i class="ti ti-package-off text-warning" style="font-size:22px;"></i>
          </div>
          <div class="blinking-dot-warning"
            style="position:absolute;top:-3px;right:-3px;width:10px;height:10px;border-radius:50%;background:#f59e0b;border:2px solid #fffbeb;">
          </div>
        </div>

        <!-- Title + Subtitle -->
        <div class="flex-grow-1">
          <h6 class="mb-0 fw-bold text-warning" style="font-size:14px;letter-spacing:0.03em;">LOW STOCK</h6>
          <p class="mb-0 text-muted" style="font-size:12px;">Restock required!</p>
        </div>

        <!-- Count Badge -->
        <div style="background:#fef9c3;border-radius:8px;padding:4px 12px;text-align:center;">
          <span class="fw-bold text-warning" style="font-size:26px;line-height:1;">{{ low_stock_count }}</span>
          <p class="mb-0 text-warning" style="font-size:10px;opacity:0.7;">items</p>
        </div>
      </div>

      <!-- Divider -->
      <hr style="border-color:#fde68a;margin:0 0 12px 0;">

      <!-- Button -->
      <router-link to="/inventory/low-stock"
        class="btn btn-warning btn-sm fw-semibold w-100 text-white"
        style="font-size:13px;border-radius:8px;">
        <i class="ti ti-eye me-1"></i>View Low Stock
      </router-link>

    </div>
  </div>
</div>

          <div class="d-flex align-items-center flex-wrap mb-1" v-if="todays_reminder > 0">
            <div class="card shadow-sm reminder-card">
              <a href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#all_reminder"
                @click="$refs.reminderModal.all();">
                <div class="card-body p-3">
                  <div class="row g-0 align-items-center">
                    <div class="col-auto">
                      <div class="reminder-indicator me-3">
                        <div class="blinking-dot"></div>
                        <i class="fas fa-bell text-muted reminder-icon"></i>
                      </div>
                    </div>
                    <div class="col">
                      <div class="d-flex justify-content-between align-items-center">
                        <div>
                          <h6 class="card-title reminder-title mb-0 fw-semibold me-2">Today's Reminders</h6>
                          <small class="text-muted">{{ $formatDate($currentDate()) }}</small>
                        </div>
                        <div class="text-end align-self-start">
                          <h4 class="text-primary mb-0 fw-bold lh-1">{{ todays_reminder }}</h4>
                          <div class="reminder-spacer"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </a>
            </div>

          </div>

          <div class="d-flex align-items-center flex-wrap mb-1" v-else>
            <a href="javascript:void(0);" class="btn btn-secondary btn-md me-2 mb-2" data-bs-toggle="modal"
              data-bs-target="#lead_modal" @click="$refs.leadModal.add();" v-if="getPermission('Lead', 'create')"><i
                class="ti ti-user-check me-1"></i>Add Lead</a>
            <a href="javascript:void(0);" class="btn btn-primary btn-md mb-2" data-bs-toggle="modal"
              data-bs-target="#quotation_modal" @click="$refs.quotationModal.add();"
              v-if="getPermission('Quotation', 'create')"><i class="ti ti-file-invoice me-1"></i>Add Quotation</a>
          </div>

        </div>
      </div>
      <!-- /Welcome Wrap -->

      <div class="row" v-if="getPermission('Lead', 'read')">
        <!-- Widget Info -->
        <div class="col-xxl-12 d-flex">
          <div class="row flex-fill">

            <div class="col-md-3 d-flex">
              <router-link :to="`/crm/leads-list?branch_id=${branch_id}`"
                class="stat-card flex-fill text-decoration-none">
                <div class="stat-card__icon-wrap bg-info">
                  <i class="ti ti-users-group fs-16"></i>
                </div>
                <div class="stat-card__body">
                  <h6 class="fs-13 fw-medium text-default mb-1">Total No of Leads</h6>
                  <h3 class="mb-3">{{ $numFormat(total.leads) }}</h3>
                  <span class="link-default">View All</span>
                </div>
              </router-link>
            </div>

            <div class="col-md-3 d-flex" v-for="(row, index) in stage_wise_lead_distribution" :key="index">
              <router-link :to="{ name: 'leads-list', query: { lead_stage_id: row.stage_id, branch_id: branch_id } }"
                class="stat-card flex-fill text-decoration-none">
                <div class="stat-card__icon-wrap" :style="{ backgroundColor: row.color || '#6c757d' }">
                  <i class="ti ti-user-shield fs-16"></i>
                </div>
                <div class="stat-card__body">
                  <h6 class="fs-13 fw-medium text-default mb-1">{{ row.stage }} Leads</h6>
                  <h3 class="mb-3">{{ $numFormat(row.count) }}</h3>
                  <span class="link-default">View {{ row.stage }}</span>
                </div>
              </router-link>
            </div>

            <div class="col-md-3 d-flex">
              <router-link :to="{ name: 'leads-list', query: { conversion: true, branch_id: branch_id } }"
                class="stat-card flex-fill text-decoration-none">
                <div class="stat-card__icon-wrap bg-success">
                  <i class="ti ti-user-check fs-16"></i>
                </div>
                <div class="stat-card__body">
                  <h6 class="fs-13 fw-medium text-default mb-1">Total Converted Leads</h6>
                  <h3 class="mb-3">{{ $numFormat(total.converted_leads) }}</h3>
                  <span class="link-default">View Converted</span>
                </div>
              </router-link>
            </div>

          </div>
        </div>
        <!-- /Widget Info -->
      </div>

      <div class="row g-4 align-items-stretch mb-4" v-if="getPermission('Lead', 'read')">

        <!-- Lead Stage Chart -->
        <div class="col-xxl-6 col-xl-6 col-12">
          <div class="card border-0 shadow-sm w-100 h-100" style="border-radius: 14px; overflow: hidden;">
            <div class="card-header bg-white border-0 px-4 pt-4 pb-2">
              <div class="d-flex align-items-center justify-content-between">
                <div>
                  <h6 class="fw-bold mb-0" style="font-size: 14px; color: #1a1a2e;">Lead Stage Distribution</h6>
                  <p class="mb-0 text-muted" style="font-size: 12px;">All active lead stages</p>
                </div>
                <div
                  style="width:34px;height:34px;border-radius:9px;background:#eff6ff;display:flex;align-items:center;justify-content:center;">
                  <i class="ti ti-chart-donut text-primary" style="font-size:18px;"></i>
                </div>
              </div>
              <hr class="mt-3 mb-0" style="border-color:#f1f1f1;">
            </div>
            <div class="card-body px-4 pb-4 pt-2">
              <LeadStageChart :chart-data="leadChartData" :chart-config="lead_stage_chart_config" :chart-key="chartKey"
                 center-label="Total Leads" @open-stage-leads="openStageLeads" />
            </div>
          </div>
        </div>

        <!-- Quotation Status Chart -->
        <div class="col-xl-6 col-12">
          <div class="col-12">
            <div class="card border-0 shadow-sm w-100" style="border-radius: 14px; overflow: hidden;">
              <div class="card-header bg-white border-0 px-4 pt-4 pb-2">
                <div class="d-flex align-items-center justify-content-between">
                  <div>
                    <h6 class="fw-bold mb-0" style="font-size: 14px; color: #1a1a2e;">Quotation Status Overview</h6>
                    <p class="mb-0 text-muted" style="font-size: 12px;">Draft, Sent, Accepted & Rejected</p>
                  </div>
                  <div
                    style="width:34px;height:34px;border-radius:9px;background:#fff7ed;display:flex;align-items:center;justify-content:center;">
                    <i class="ti ti-file-invoice" style="font-size:18px; color: #29B6F6;"></i>
                  </div>
                </div>
                <hr class="mt-3 mb-0" style="border-color:#f1f1f1;">
              </div>
              <div class="card-body px-4 pb-4 pt-2">
                <QuotationChart :chart-data="quotationReportData" :chart-config="quotation_status_chart_config"
                  :chart-key="chartKeyQuotationStatus"/>
              </div>
            </div>
          </div>
          <div class="col-12" v-if="getPermission('User', 'read')">
            <div class="card border-0 shadow-sm w-100" style="border-radius: 14px; overflow: hidden;">
              <div class="card-header bg-white border-0 px-4 pt-4 pb-2">
                <div class="d-flex align-items-center justify-content-between">
                  <div>
                    <h6 class="fw-bold mb-0" style="font-size: 14px; color: #1a1a2e;">Users By Roles</h6>
                    <p class="mb-0 text-muted" style="font-size: 12px;">Role-wise user distribution</p>
                  </div>
                  <div
                    style="width:34px;height:34px;border-radius:9px;background:#f0fdf4;display:flex;align-items:center;justify-content:center;">
                    <i class="ti ti-users text-success" style="font-size:18px;"></i>
                  </div>
                </div>
                <hr class="mt-3 mb-0" style="border-color:#f1f1f1;">
              </div>
              <div class="card-body px-4 pb-4 pt-2">
                <apexchart :key="chartKeyUserRole" type="bar" height="300" :options="user_roles.roles"
                  :series="user_roles.series" />
              </div>
            </div>
          </div>
        </div>


      </div>

      <div class="row" v-if="getPermission('Lead', 'read')">

        <div class="col-md-5">
          <LeadSourceChart :chart-data="source_wise_lead_distribution" :title="'Lead Source Distribution'" />
        </div>

        <div class="col-md-7">
          <TopSellingItemChart :chart-data="top_selling_items" :title="'Top 10 Selling Items'" />
        </div>

      </div>



    </div>

    <app-footer></app-footer>

  </div>

  <leads-modal ref="leadModal"></leads-modal>
  <chart-modal ref="chartModal"></chart-modal>
  <reminder-modal ref="reminderModal"></reminder-modal>
  <quotation-modal ref="quotationModal"></quotation-modal>

</template>

<style scoped>
.reminder-card {
  min-height: 60px;
  max-height: 75px;
  width: 100%;
  transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
  border: 1px solid #dee2e6;
  border-radius: 8px;
}

.reminder-card:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1) !important;
}

.reminder-indicator {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 40px;
}

.reminder-icon {
  font-size: 1.5rem !important;
  opacity: 0.7;
}

.blinking-dot {
  position: absolute;
  top: -2px;
  right: -2px;
  width: 10px;
  height: 10px;
  background-color: #dc3545;
  border-radius: 50%;
  border: 2px solid white;
  animation: blink-animation 1.5s ease-in-out infinite;
  z-index: 10;
}

@keyframes blink-animation {

  0%,
  100% {
    opacity: 1;
    transform: scale(1);
  }

  50% {
    opacity: 0.2;
    transform: scale(0.7);
  }
}

.reminder-title {
  font-size: 0.95rem;
  color: #495057;
  line-height: 1.2;
}

.count-container {
  min-width: 60px;
  position: relative;
}

.text-primary {
  color: #0d6efd !important;
  font-size: 1.8rem;
  line-height: 1 !important;
}

.reminder-spacer {
  height: 16px;
  width: 100%;
}

.text-muted {
  font-size: 0.75rem;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .reminder-card {
    min-height: 65px;
  }

  .text-primary {
    font-size: 1.5rem;
  }

  .reminder-icon {
    font-size: 1.3rem;
  }

  .count-container {
    min-width: 50px;
  }
}
</style>
<style scoped>
.stat-card {
  position: relative;
  background: #ffffff;
  border-radius: 12px;
  /* box-shadow: 0 1px 6px rgba(0, 0, 0, 0.07); */
  overflow: visible;
  transition: box-shadow 0.2s ease, transform 0.2s ease;
  margin-bottom: 15px;
}

.stat-card:hover {
  /* box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1); */
  transform: translateY(-2px);
}

/* Floating circle icon — top-right, overflowing card */
.stat-card__icon-wrap {
  position: absolute;
  top: 1px;
  right: 0px;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  outline: 10px solid #f2f6fe;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  font-size: 20px;
  /* box-shadow: 0 4px 14px rgba(0, 0, 0, 0.2); */
  z-index: 1;
}
.blinking-dot-warning {
  animation: blink-animation 1.5s ease-in-out infinite;
}

.blinking-dot-danger {
  animation: blink-animation 1.5s ease-in-out infinite;
}

/* .stat-card__icon-wrap::before, .stat-card__icon-wrap::after {
    content: "";
    position: absolute;
    width: 25px;
    height: 25px;
    background-color: transparent;
    pointer-events: none;
}
.stat-card__icon-wrap::before {
    top: 9px;
    left: -14px;
    border-top-right-radius: 0px;
    box-shadow: 7px -11px 0 0 #fff;
    height: 1px;
    width: 10px;
    border-bottom-right-radius: 28px;
} */
.stat-card__icon-wrap::after {
  bottom: -17px;
  right: 6px;
  border-top-left-radius: 30px;
  box-shadow: 7px -9px 0 0 #fff;
  width: 1px;
  height: 9px;
}

.stat-card__body {
  padding: 24px 16px 16px;
}
</style>